import React from 'react';
import { motion } from 'framer-motion';
export function ProductPreview() {
  return <section className="py-16 md:py-20 bg-brand-cream-dark overflow-hidden" data-id="element-170">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-heading text-brand-slate mb-4" data-id="element-173">
            Mira lo que vas a recibir
          </h2>
          <p className="text-lg text-brand-slate-light max-w-2xl mx-auto" data-id="element-174">
            Un material diseñado para ser fácil de leer, práctico y directo al
            punto.
          </p>
        </motion.div>

        <div className="relative max-w-4xl mx-auto" data-id="element-175">
          {/* Main Device/Book Mockup */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative z-20 bg-white rounded-3xl shadow-2xl p-4 md:p-8 border border-brand-slate/5" data-id="element-176">
            <div className="aspect-auto md:aspect-[16/10] bg-brand-cream rounded-xl overflow-hidden relative border border-brand-slate/10 flex flex-col md:flex-row" data-id="element-177">
              {/* Left Page */}
              <div className="w-full md:w-1/2 h-auto md:h-full border-b md:border-b-0 md:border-r border-brand-slate/10 p-6 md:p-10 flex flex-col justify-center bg-white" data-id="element-178">
                <div className="w-12 h-1 bg-brand-amber mb-6" data-id="element-179"></div>
                <h3 className="text-2xl md:text-4xl font-heading text-brand-slate mb-4" data-id="element-180">
                  Capítulo 3: El Miedo al Error
                </h3>
                <p className="text-brand-slate-light text-sm md:text-base leading-relaxed mb-4" data-id="element-181">
                  El error no es lo opuesto al éxito, es parte del proceso.
                  Cuando un jugador entiende esto, la presión disminuye
                  drásticamente.
                </p>
                <div className="space-y-2 mt-6 md:mt-auto" data-id="element-182">
                  <div className="h-2 bg-brand-cream-dark rounded w-full" data-id="element-183"></div>
                  <div className="h-2 bg-brand-cream-dark rounded w-5/6" data-id="element-184"></div>
                  <div className="h-2 bg-brand-cream-dark rounded w-4/6" data-id="element-185"></div>
                </div>
              </div>
              {/* Right Page */}
              <div className="w-full md:w-1/2 h-auto md:h-full p-6 md:p-10 bg-brand-green text-white flex flex-col justify-center relative overflow-hidden" data-id="element-186">
                <div className="absolute inset-0 opacity-10 bg-[url('https://images.unsplash.com/photo-1518605368461-1e1e111e1ebc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80')] bg-cover bg-center mix-blend-overlay" data-id="element-187"></div>
                <div className="relative z-10" data-id="element-188">
                  <h4 className="text-xl md:text-2xl font-heading text-brand-amber mb-4" data-id="element-189">
                    Ejercicio Práctico
                  </h4>
                  <div className="bg-white/10 p-4 rounded-lg backdrop-blur-sm border border-white/20 mb-4" data-id="element-190">
                    <p className="text-sm md:text-base font-medium" data-id="element-191">
                      1. Identifica el pensamiento limitante.
                    </p>
                  </div>
                  <div className="bg-white/10 p-4 rounded-lg backdrop-blur-sm border border-white/20 mb-4" data-id="element-192">
                    <p className="text-sm md:text-base font-medium" data-id="element-193">
                      2. Reemplázalo por una instrucción táctica.
                    </p>
                  </div>
                  <div className="bg-white/10 p-4 rounded-lg backdrop-blur-sm border border-white/20" data-id="element-194">
                    <p className="text-sm md:text-base font-medium" data-id="element-195">
                      3. Respira y vuelve al presente.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Floating elements behind */}
          <motion.div initial={{
          opacity: 0,
          x: -50,
          rotate: -10
        }} whileInView={{
          opacity: 1,
          x: 0,
          rotate: -6
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="absolute -left-12 md:-left-24 top-20 w-48 md:w-64 aspect-[3/4] bg-white rounded-xl shadow-xl border border-brand-slate/10 p-4 z-10 hidden sm:block" data-id="element-196">
            <div className="w-full h-full bg-brand-cream rounded-lg border border-brand-slate/5 p-4 flex flex-col" data-id="element-197">
              <div className="w-8 h-8 rounded-full bg-brand-amber/20 mb-4" data-id="element-198"></div>
              <div className="h-4 bg-brand-slate/20 rounded w-3/4 mb-2" data-id="element-199"></div>
              <div className="h-3 bg-brand-slate/10 rounded w-full mb-2" data-id="element-200"></div>
              <div className="h-3 bg-brand-slate/10 rounded w-5/6 mb-4" data-id="element-201"></div>
              <div className="mt-auto grid grid-cols-2 gap-2" data-id="element-202">
                <div className="h-16 bg-brand-green/10 rounded" data-id="element-203"></div>
                <div className="h-16 bg-brand-green/10 rounded" data-id="element-204"></div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50,
          rotate: 10
        }} whileInView={{
          opacity: 1,
          x: 0,
          rotate: 6
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="absolute -right-12 md:-right-24 bottom-10 w-48 md:w-64 aspect-[3/4] bg-white rounded-xl shadow-xl border border-brand-slate/10 p-4 z-10 hidden sm:block" data-id="element-205">
            <div className="w-full h-full bg-brand-green rounded-lg border border-brand-green-light p-4 flex flex-col items-center justify-center text-center" data-id="element-206">
              <div className="text-brand-amber font-heading text-2xl mb-2" data-id="element-207">
                Checklist
              </div>
              <div className="w-full space-y-3 mt-4" data-id="element-208">
                <div className="flex items-center gap-2" data-id="element-209">
                  <div className="w-4 h-4 rounded bg-brand-amber" data-id="element-210"></div>
                  <div className="h-2 bg-white/50 rounded w-full" data-id="element-211"></div>
                </div>
                <div className="flex items-center gap-2" data-id="element-212">
                  <div className="w-4 h-4 rounded bg-brand-amber" data-id="element-213"></div>
                  <div className="h-2 bg-white/50 rounded w-full" data-id="element-214"></div>
                </div>
                <div className="flex items-center gap-2" data-id="element-215">
                  <div className="w-4 h-4 rounded bg-brand-amber" data-id="element-216"></div>
                  <div className="h-2 bg-white/50 rounded w-full" data-id="element-217"></div>
                </div>
                <div className="flex items-center gap-2" data-id="element-218">
                  <div className="w-4 h-4 rounded border border-white/50" data-id="element-219"></div>
                  <div className="h-2 bg-white/50 rounded w-full" data-id="element-220"></div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}